export default (input: any, ...args: any[]): any =>
  typeof input === 'function' ? input(...args) : input;
